export default "__VITE_ASSET__CEa5jHEX__"